var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report', {
    attrs: {
      "renderBackAndForthFooter": false,
      "isProgressDone": true,
      "showFooter": false
    }
  }, [_c('v-container', {
    staticClass: "padded"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('h1', [_vm._v("Allgemeine Geschäftsbedingungen")])]), _c('v-card-text', [_c('p', {
    staticClass: "MsoNormal"
  }, [_vm._v(" Stand: 20.03.2023 ")]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("1. Geltungsbereich")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("1.1 Die MMM Intelligence UG (haftungsbeschränkt) („Anbieter“) hat eine App entwickelt, durch welche Fahrzeughalter Schäden an ihrem Fahrzeug digital dokumentieren und direkt an Reparaturwerkstätten übermitteln können („App“). Diese App ist so konzipiert, dass sie direkt in die Website von Kunden des Anbieters („Vertragspartners“) eingebunden werden kann, um so eine digitale Anlaufstelle für Neu- und Bestandskunden zu bieten.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("1.2 Diese Allgemeinen Geschäftsbedingungen („AGB“) gelten für sämtliche Verträge, die der Anbieter mit Dritten über die Verwendung der App abschließt. Diese AGB gelten ausschließlich. Geschäftsbedingungen des Vertragspartners werden nur insoweit Vertragsbestandteil, als der Anbieter ihrer Geltung ausdrücklich schriftlich zugestimmt hat.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("1.3 Das Angebot des Anbieters im Hinblick auf die Verwendung der App richtet sich ausschließlich an Unternehmer, also an natürliche oder juristische Personen oder rechtsfähige Personengesellschaften, die in Ausübung einer gewerblichen oder selbstständigen beruflichen Tätigkeit handeln, sowie an juristische Personen des öffentlichen Rechts oder öffentlich-rechtliche Sondervermögen. Ein Vertragsschluss mit Verbrauchern findet nicht statt.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("2. Vertragsgegenstand")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("2.1 Gegenstand des Angebots des Anbieters ist die Bereitstellung der App auf einer von dem Anbieter betriebenen Website, die optisch der Website des Geschäftspartners nachempfunden ist und dessen Namen der folgenden Struktur entsprechend in ihrer Website-Adresse trägt: https://geschäftspartner.schadensmeldung.digital („Website“). Der Geschäftspartner kann diese Website dann durch eine entsprechende Verlinkung in seinen eigenen Internetauftritt einbinden.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("2.2 Nach der Bereitstellung der App gemäß Ziffer 2.1 können Besucher der Website die App nutzen, um Schäden an Kraftfahrzeugen zu erfassen und zu dokumentieren und eine Schadensmeldung abzugeben, die dann von dem Anbieter unmittelbar an den Geschäftspartner übermittelt wird. Der Geschäftspartner erhält zudem die Möglichkeit, über die Nutzeroberfläche der App Details zu den jeweiligen Schadensmeldungen einzusehen. Eine vollständige Funktionsbeschreibung der App ist auf der Website des Anbieters abrufbar.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("2.3 Der Anbieter ist berechtigt, die Funktionen und Ausgestaltung der App im Einzelnen jederzeit zu ändern, anzupassen und zu updaten, soweit hierdurch ihre zentralen Funktionen nicht wesentlich verändert oder beeinträchtigt werden. Über sämtliche Änderungen, Anpassungen und Updates wird der Nutzer vorab informiert.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("3. Vertragsschluss")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("3.1 Alle Angebote und Preislisten des Anbieters sind freibleibend und unverbindlich, sofern sie nicht ausdrücklich als verbindlich gekennzeichnet sind oder eine bestimmte Annahmefrist enthalten.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("3.2 Ein Vertrag zwischen dem Anbieter und dem Geschäftspartner kommt zustande, indem der Kunde ein mündliches oder schriftliches Vertragsangebot abgibt, das ausdrücklich von dem Anbieter angenommen wird. Falls der Anbieter dem Geschäftspartner keine individuellen Preis- und Leistungsangaben zur Verfügung gestellt hat, sind die jeweils aktuellen Leistungsbeschreibungen und Preisangaben des Anbieters Bestandteil dieses Angebots und werden Bestandteil des Vertrages zwischen dem Anbieter und dem Kunden, falls ein solcher zustande kommt.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("4. Bereitstellung und Verfügbarkeit der Ap")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("4.1 Der Anbieter schuldet lediglich die Bereitstellung der App auf der von ihm eingerichteten Website, wobei er sich auf Wunsch des Geschäftspartners bei der optischen Gestaltung der Benutzeroberfläche an dem Design des Internetauftritts des Geschäftspartners orientiert. Der Anbieter kann insbesondere an der dafür standardmäßig vorgesehenen Stelle das Logo oder den Namenszug des Nutzers hinterlegen („Customization“).")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("4.2 Der Anbieter schuldet eine zuverlässige technische Nutzbarkeit der App zum Gebrauch durch den Geschäftspartner bzw. durch dessen Kunden auf der Website. Angestrebt wird eine jährliche Verfügbarkeit von durchschnittlich 95 % der Betriebszeit. Dabei berechnet sich die Verfügbarkeit nach der folgenden Formel: Verfügbarkeit = (Gesamtzeit - Gesamtausfallzeit) / Gesamtzeit * 100 %.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("4.3 Bei der Berechnung der Gesamtausfallzeit bleiben folgende Zeiten außer Betracht:")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("4.3.1 Zeiten der Nichtverfügbarkeit, die auf von mmmint.ai nicht beeinflussbaren Störungen des Internets oder auf sonstigen von mmmint.ai nicht zu vertretenden Umständen, insbesondere auf einer Epidemie oder Pandemie (wie Covid-19) oder auf höherer Gewalt beruhen;")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("4.3.2 Zeiten der Nichtverfügbarkeit wegen geplanter Wartungsarbeiten an der App")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("4.3.3 Zeiten wegen zwingend erforderlicher außerplanmäßiger Wartungsarbeiten, die zur Beseitigung von Störungen erforderlich sind; der Nutzer wird hiervon nach Möglichkeit im Voraus elektronisch in Kenntnis gesetzt (z. B. per E-Mail, auf der Website);")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("4.3.4 Zeiten der Nichtverfügbarkeit, die darauf beruhen, dass die vom Nutzer zu schaffenden erforderlichen technischen Voraussetzungen für den Zugang zu der App vorübergehend nicht gegeben sind, beispielsweise bei Störungen der Hardware des Nutzers.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("5. Pflichten des Geschäftspartners")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("5.1 Der Geschäftspartner verpflichtet sich, die App lediglich für die vertraglich vorausgesetzten Zwecke und in dem vertraglich vorausgesetzten Umfang zu verwenden.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("5.2 Der Geschäftspartner verpflichtet sich, den im Rahmen der App ggf. möglichen Austausch von elektronischen Nachrichten nicht missbräuchlich für den unaufgeforderten Versand von Nachrichten und Informationen an Dritte zu Werbezwecken oder für den Versand von Nachrichten, die gegen gesetzliche oder untergesetzliche Regelungen oder Rechte Dritter verstoßen zu nutzen.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("5.3 Der Geschäftspartner wird die ihm bzw. den Nutzern seines Unternehmens zugeordneten Nutzungs- und Zugangsberechtigungen sowie die vereinbarten Identifikations- und Authentifikations-Sicherungen geheim halten, vor dem Zugriff durch Dritte schützen und nicht an unberechtigte Nutzer weitergeben. Diese Daten sind durch geeignete und übliche Maßnahmen zu schützen. Der Nutzer wird den Anbieter unverzüglich unterrichten, wenn der Verdacht besteht, dass die Zugangsdaten und/oder Kennwörter nichtberechtigten Personen bekannt geworden sein könnten;")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("5.4 Verletzt der Geschäftspartner die Regelungen nach dieser Ziffer aus von ihm zu vertretenden Gründen, kann der Anbieter den Zugriff des Anbieters auf die App sperren und/oder die Bereitstellung der App über die Website vorübergehend oder dauerhaft beenden, wenn die Verletzung hierdurch nachweislich abgestellt werden kann.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("6. Schutzrechte")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("6.1 Sämtliche an der App bestehenden Schutzrechte bleiben unberührt. Der Geschäftspartner erkennt an, dass es sich bei der App und der zugrundeliegenden Software um Computerprogramme i.S.v. § 69a Abs. 3 S. 1 UrhG handelt. Der Nutzer erkennt an, dass die App und die zugrundeliegende Software und sämtliche Ideen, Methoden, Algorithmen, Formeln, Prozesse und Konzepte, die in die Entwicklung der App und Software und in die App und Software selbst Eingang fanden, sämtliche zukünftigen Aktualisierungen und Upgrades, alle sonstigen Verbesserungen, Überarbeitungen und Erweiterungen, Betriebsgeheimnisse und urheberrechtlich geschütztes Eigentum des Anbieters mit großem wirtschaftlichen Wert für den Anbieter darstellen.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("6.2 Marken, Firmenlogos, sonstige Kennzeichen oder Schutzvermerke, Urhebervermerke, Seriennummern sowie sonstige der Identifikation dienende Merkmale dürfen weder im elektronischen Format noch in Ausdrucken entfernt oder verändert werden.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("6.3 Der Geschäftspartner versichert, dass er berechtigt ist, denjenigen Namen zu tragen und im geschäftlichen Verkehr zu verwenden, unter dem die Website erreichbar sein soll und dass er berechtigt ist, sämtliche für die Customization übermittelten Designs, Marken, Logos, Namen und sonstigen Inhalte („Designs“) für diese Zwecke zu nutzen.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("6.4 Der Geschäftspartner haftet ohne Rücksicht auf ein etwaiges Verschulden für sämtliche Schäden, die wegen einer möglichen Verletzung fremder Schutzrechte im Hinblick auf die von ihm gewünschten Namen der Website und allen weiteren auf seinen Wunsch verwendeten Designs entstehen und stellt den Anbieter insoweit von sämtlichen Schadensersatzansprüchen Dritter frei")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("7. Vergütung")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("7.1 Der Geschäftspartner verpflichtet sich, für die Bereitstellung der App und die Übermittlung der digitalen Schadensmeldungen die vertraglich vereinbarte Vergütung zu entrichten. Falls die Parteien nichts Abweichendes vereinbart haben, werden die entsprechenden Leistungen des Anbieters monatlich abgerechnet.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("7.2 Der auf der Rechnung angegebene Rechnungsbetrag ist nach Erhalt der Rechnung fällig und innerhalb von 10 Werktagen zu zahlen.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("7.3 Alle Preise sind Nettopreise, sofern nicht ausdrücklich anders angegeben.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("8. Haftung auf Schadensersatz")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("8.1 Der Anbieter haftet dem Nutzer gegenüber in allen Fällen vertraglicher und außervertraglicher Haftung bei Vorsatz und grober Fahrlässigkeit nach Maßgabe der gesetzlichen Bestimmungen auf Schadensersatz oder Ersatz vergeblicher Aufwendungen.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("8.2 In sonstigen Fällen haftet der Anbieter - soweit in Ziffer 8.3 nicht abweichend geregelt - nur bei Verletzung einer Vertragspflicht, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf deren Einhaltung der Nutzer regelmäßig vertrauen darf (sog. Kardinalpflicht), und zwar beschränkt auf den Ersatz des vorhersehbaren und typischen Schadens. In allen übrigen Fällen ist die Haftung des Anbieters - vorbehaltlich der Regelung in Ziffer 8.3 - ausgeschlossen.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("8.3 Die Haftung des Anbieters für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit und nach dem Produkthaftungsgesetz bleibt von den vorstehenden Haftungsbeschränkungen und –ausschlüssen unberührt.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("9. Datenschutz, Datensicherheit")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("9.1 Der Geschäftspartner verpflichtet sich, soweit gesetzlich erforderlich, einen Vertrag zur Auftragsverarbeitung im Sinne von Art. 28 DS-GVO mit dem Anbieter zu schließen und die gesetzlichen Regelungen zum Datenschutz im Hinblick auf etwaig von dem Anbieter übermittelten oder offengelegten personenbezogenen Daten einzuhalten.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("9.2 Die Bestimmungen und Informationen zum Datenschutz betreffend den Anbieter ergeben sich aus der jeweils geltenden Fassung der Datenschutzerklärung des Anbieters.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("10. Markennutzung vom Namen des Geschäftspartners")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("Der Anbieter hat das Recht, den Geschäftspartner als Kunden oder Partner zu kommunizieren und dafür auch das Markenzeichen des Abnehmers zu verwenden, beispielsweise auf der Website auf den Geschäftspartner als Kunden oder Partner hinzuweisen. Der Geschäftspartner kann einer solchen Nutzung jederzeit widersprechen. Eine Markennutzung in Pressemitteilungen bedarf der vorherigen Zustimmung des Geschäftspartners.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("11. Vertragsdauer und Kündigung")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("11.1 Der Vertrag wird auf unbestimmte Dauer geschlossen. Er kann durch die Parteien jeweils mit einer Frist von zwei Wochen zum Monatsende gekündigt werden. Das Recht zur Kündigung aus wichtigem Grund bleibt unberührt.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("11.2 Kündigungen bedürfen zu ihrer Wirksamkeit der Schriftform.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("12. Änderung der AGB")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("12.1 Der Anbieter kann diese Bedingungen jederzeit ändern, wenn die Änderung für den Kunden lediglich vorteilhaft ist, wenn ein Änderungsbedarf aufgrund bestimmter gesetzlicher Vorgaben oder gerichtlicher oder behördlicher Entscheidungen oder einer solchen Entscheidung gegen den Anbieter besteht sowie bei technischen Überarbeitungen, die eine Änderung der Bedingungen erfordern und für den Geschäftspartner zumutbar sind.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("12.2 Über eine von dem Anbieter beabsichtigte Änderung dieser Bedingungen wird der Geschäftspartner mindestens vier Wochen vor dem geplanten Änderungszeitpunkt in Textform (z.B. per E-Mail) informiert. Die Zustimmung gilt als erteilt, wenn der Geschäftspartner der Geltung der neuen Fassung nicht bis zum geplanten Änderungszeitpunkt gegenüber dem Anbieter widerspricht. Geschäftspartner, die nicht zustimmen, können den Vertrag mit dem Anbieter jederzeit - nicht nur vor dem geplanten Änderungszeitpunkt, sondern auch danach - kündigen. Der Geschäftspartner wird von dem Anbieter im Rahmen der Bekanntgabe der beabsichtigten Änderungen nochmals gesondert darauf hingewiesen, dass das Schweigen als Zustimmung zu den Änderungen gilt und der Geschäftspartner den Vertrag jederzeit kündigen kann.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("13. Schlussbestimmungen")])])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("13.1 Diese Vertragsbedingungen unterliegen ausschließlich deutschem Recht unter Ausschluss des UN-Kaufrechts. Ausschließlicher Gerichtsstand ist der Sitz des Anbieters in Osnabrück.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v("13.2 Die Parteien sind nicht berechtigt, Ansprüche oder sonstige Rechte aus diesem Vertrag ohne Zustimmung der jeweils anderen Parteien zu übertragen, zu verpfänden oder in sonstiger Weise zu belasten.")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v(" 13.3 Änderungen, Ergänzungen oder die Aufhebung dieses Vertrages einschließlich der Änderung dieser Ziffer 13 bedürfen der Schriftform (i. S. d. § 126 BGB), soweit nicht zwingend eine andere Form vorgeschrieben ist. ")])]), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    attrs: {
      "lang": "DE"
    }
  }, [_vm._v(" 13.4 Sollten Bestimmungen dieses Vertrages ganz oder teilweise nicht rechtswirksam oder durchführbar sein oder werden, so wird hierdurch die Gültigkeit der übrigen Bestimmungen dieses Vertrages nicht berührt. Das gleiche gilt, soweit sich in diesem Vertrag eine Lücke herausstellen sollte. Anstelle der unwirksamen oder undurchführbaren Bestimmung oder zur Ausfüllung der Lücke soll eine angemessene Regelung gelten, die, soweit rechtlich möglich, dem am nächsten kommt, was die Parteien gewollt haben oder nach dem Sinn und Zweck dieses Vertrages gewollt hätten, sofern sie bei dem Abschluss dieses Vertrages oder der späteren Aufnahme einer Bestimmung den Punkt bedacht hätten. Dies gilt auch dann, wenn die Unwirksamkeit einer Bestimmung etwa auf einem in diesem Vertrag vorgesehenen Umfang der Leistung oder Zeit (Frist oder Termin) beruht; es tritt in solchen Fällen ein dem Gewollten möglichst nah kommendes rechtlich zulässiges Maß der Leistung oder Zeit (Frist oder Termin) an die Stelle des Vereinbarten. Es ist ausdrücklich Wille der Parteien, dass diese salvatorische Klausel nicht eine bloße Beweislastumkehr zur Folge hat, sondern § 139 BGB insgesamt abbedungen ist. ")])])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }